import { render, staticRenderFns } from "./aOwnerDetailHis.vue?vue&type=template&id=2550070b&scoped=true"
import script from "./aOwnerDetailHis.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailHis.vue?vue&type=script&lang=js"
import style0 from "./aOwnerDetailHis.vue?vue&type=style&index=0&id=2550070b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550070b",
  null
  
)

export default component.exports